import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'

type Props = {
  orderValue: number
  minimumOrderValue: number
  minimum_order_value_snippet: any
  'data-cy-state': string
}

export default function MinimumOrderValue(props: Props) {
  const [percentage, setPercentage] = React.useState(
    (props.orderValue / props.minimumOrderValue) * 100
  )

  React.useEffect(() => {
    setPercentage((props.orderValue / props.minimumOrderValue) * 100)
  }, [props.orderValue, props.minimumOrderValue])

  return (
    <Wrapper
      data-cy-state={props['data-cy-state']}
      $percentage={percentage}
      className="MinimumOrderValue"
    >
      <div className="description">{props.minimum_order_value_snippet}</div>
      <div className="progress-bar">
        <div className="progress" />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div<{
  $percentage: number
}>`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.shade.b7};
  margin-top: ${theme.spacing('m')};
  padding: ${theme.spacing('m')};
  gap: ${theme.spacing('m')};
  > .description {
    ${theme.ty('r-base')};
  }
  > .progress-bar {
    background-color: ${theme.colors.shade.b5};
    height: ${theme.spacing('xs')};
    width: 100%;
    border-radius: ${theme.spacing('xxs')};
    > .progress {
      border-radius: ${theme.spacing('xxs')};
      background-color: ${theme.colors.accent.green};
      height: 100%;
      transition: width 0.5s;
      width: ${(p) => p.$percentage}%;
    }
  }
`
